
























































































































































import RecurringInterventionsListFilters from "./RecurringInterventionsListPartials/RecurringInterventionsListFilters.vue";
import RecurringInterventionRow from "./RecurringInterventionsListPartials/RecurringInterventionRow.vue";
import ExportButton from "../core/UI/ExportButton.vue";
import Pagination from "../core/UI/Pagination.vue";
import PerPage from "../core/UI/PerPage.vue";
import { RecurrenceInterventionApi } from "../api/RecurrenceInterventionApi";
import { Intervention } from "../models/Intervention";
import RecurrenceInterventionModal from "./RecurrenceInterventionModal.vue";
import RemplacementModal from "./RemplacementModal.vue";
import { RecurrenceIntervention } from "../models/RecurrenceIntervention";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";
import _ from "lodash";

export default {
    name: "RecurringInterventionsList",
    components: {
        RemplacementModal,
        RecurrenceInterventionModal,
        RecurringInterventionsListFilters,
        RecurringInterventionRow,
        ExportButton,
        Pagination,
        PerPage,
    },
    props: {
        defaultFilters: URLSearchParams,
    },
    data() {
        return {
            interventions: [],
            loading: false,
            filters: {},
            selectMode: false,
            selectAll: false,
            filteredIds: [],
            totalPages: 1,
            currentPage: 1,
            itemsPerPage: 10,
            frequences: Intervention.Frequence,
            RecurrenceInterventionApi: new RecurrenceInterventionApi(),
            editModal: {
                id: null,
                new: false,
            },
            remplacementModal: {
                selectedInterventionsIds: [],
                newRemplacement: false,
                defaultEmploye: null,
            },
        };
    },
    created() {
        this.loadInterventions();
    },
    methods: {
        loadInterventions() {
            this.loading = true;
            const params = this.buildApiParams();

            this.RecurrenceInterventionApi.getAll(params)
                .then((response) => {
                    this.interventions = response.data;
                    this.filteredIds = response.metadata.filtered_ids;
                    this.totalPages = response.paginator
                        ? response.paginator.total_pages
                        : 1;
                    this.loading = false;
                })
                .catch((error) => {
                    console.error(
                        "Error loading recurring interventions:",
                        error
                    );
                    this.loading = false;
                });
        },
        buildApiParams() {
            return {
                page: this.currentPage,
                limit: this.itemsPerPage,
                include: "assigned_employes,remplacements",
                ...this.filters,
            };
        },
        updateFilters(newFilters) {
            this.filters = newFilters;
            this.currentPage = 1;
            this.loadInterventions();
        },
        updateSort(sortData) {
            this.updateFilters({ sort: sortData });
        },
        getExportParams() {
            return { ...this.filters };
        },
        loadPage(page) {
            this.currentPage = page;
            this.loadInterventions();
        },
        onSelectAll() {
            this.interventions.forEach((intervention) => {
                intervention.selected = this.selectAll;
            });
        },
        onInterventionSelect(intervention) {
            // Handle individual intervention selection
            const selectedCount = this.interventions.filter(
                (i) => i.selected
            ).length;
            this.selectAll = selectedCount === this.interventions.length;
        },
        // Modal édition
        addIntervention() {
            this.editModal.id = null;
            this.editModal.new = true;
        },
        editIntervention(interventionId) {
            this.editModal.id = interventionId;
            this.editModal.new = false;
        },
        onModalClose() {
            this.editModal.id = null;
            this.editModal.new = false;
        },
        // Remplacement modal
        addRemplacement() {
            let selectedInterventionsIds = this.getSelectedInterventionsIds();
            if (selectedInterventionsIds.length === 0) {
                swal("Aucune intervention sélectionnée", "", "warning");
                return;
            }
            this.remplacementModal.selectedInterventionsIds =
                selectedInterventionsIds;
            this.remplacementModal.newRemplacement = true;
            this.remplacementModal.defaultEmploye =
                this.getDefaultRemplacementEmploye();
        },
        onRemplacementModalClose() {
            this.remplacementModal.selectedInterventionsIds = [];
            this.remplacementModal.newRemplacement = false;
            this.remplacementModal.defaultEmploye = null;
            this.loadInterventions();
        },
        getDefaultRemplacementEmploye() {
            let res = null;
            this.interventions.forEach((intervention) => {
                if (
                    intervention.selected &&
                    intervention.assigned_employes.length > 0
                ) {
                    return (res = intervention.assigned_employes[0]);
                }
            });
            return res;
        },
        getSelectedInterventionsIds(): Array<number> {
            let res = [];
            if (this.selectAll) {
                res = this.filteredIds;
            } else {
                this.interventions.forEach((intervention) => {
                    if (intervention.selected) {
                        res.push(intervention.id);
                    }
                });
            }
            return res;
        },
        // Select mode
        toggleSelectMode() {
            this.selectMode = !this.selectMode;
            if (!this.selectMode) {
                this.selectAll = false;
                this.interventions.forEach((i) => (i.selected = false));
            }
        },
        // Actions
        doAction(action, data = null) {
            switch (action) {
                case "add-intervention":
                    this.addIntervention();
                    break;
                case "edit-intervention":
                    this.editIntervention(data.id);
                    break;
                case "update-intervention":
                    this.RecurrenceInterventionApi.setArchived(
                        data.id,
                        data.archived
                    ).then(() => {
                        this.loadInterventions();
                    });
                    break;
                case "delete-intervention":
                    // Le titre est affiché en HTML par sweetalert.
                    ConfirmSuppression.demanderRaison(
                        `Voulez vous supprimer l'intervention planifiée "${_.escape(
                            data.titre
                        )}"&nbsp;?`,
                        "Ses interventions du jour et à venir seront supprimées définitivement."
                    ).then((raison) => {
                        if (raison === null) {
                            return;
                        }
                        this.RecurrenceInterventionApi.remove(data.id, raison)
                            .then(() => {
                                this.loadInterventions();
                                swal(
                                    "Intervention planifiée supprimée !",
                                    "",
                                    "success"
                                );
                            })
                            .catch((error) => {
                                let response =
                                    (error.response && error.response.data) ||
                                    {};
                                swal(
                                    "Suppression impossible",
                                    response.message ||
                                        (response.error &&
                                            response.error.message) ||
                                        "",
                                    "error"
                                );
                            });
                    });
                    break;
                default:
                    this.$emit("action", action, data);
            }
        },
    },
    watch: {
        itemsPerPage: function () {
            this.currentPage = 1;
            this.loadInterventions();
        },
    },
};
